/* Happymami · PDP Pack termo + dosificador — movimiento con el scroll (entrada y salida).
   Anima las secciones de abajo (.hm-pk) y las reseñas y preguntas que van debajo. Sin librerías.
   Respeta «Reducir movimiento» y no esconde nada en el editor del tema. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  if (reduced || editor || !('IntersectionObserver' in window)) return;
  var main = document.getElementById('MainContent');
  var pk = main && main.querySelector('.hm-pk');
  if (!pk) return;
  var small = window.matchMedia && window.matchMedia('(max-width: 899.98px)').matches;
  var HOLD = 400;
  var enterIO, exitIO;
  var all = [];

  // Al salir de la página (o ponerla en la caché de atrás/adelante) los observadores pueden dar «fuera de pantalla» para todo:
  // mientras dura, no se ocultan bloques; al volver se repasan.
  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('pageshow', function () { leaving = false; });

  // Cada bloque entra al asomar y sale al irse (por arriba o por abajo). Histéresis: la entrada y la salida usan franjas
  // distintas y un bloque no cambia de estado dos veces en menos de 400 ms.
  function setState(el, inside, up) {
    if (leaving && !inside) return;
    var now = Date.now();
    if (el.__pkT && now - el.__pkT < HOLD) return;
    if (inside) {
      if (el.classList.contains('pk-in')) return;
      el.__pkT = now;
      el.classList.remove('pk-up', 'pk-down');
      el.classList.add('pk-in');
    } else {
      if (!el.classList.contains('pk-in')) return;
      el.__pkT = now;
      el.classList.remove('pk-in');
      el.classList.toggle('pk-up', !!up);
      el.classList.toggle('pk-down', !up);
    }
  }
  function build() {
    enterIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && (small || e.intersectionRatio >= 0.1)) {
          setState(e.target, true);
          (e.target.__fol || []).forEach(function (f) { setState(f, true); });
        }
      });
    }, { threshold: [0, 0.1], rootMargin: small ? '-6% 0px -10% 0px' : '0px 0px -8% 0px' });
    exitIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) setState(e.target, false, e.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: small ? '0% 0px -2% 0px' : '4% 0px 4% 0px' });
  }
  function reveal(el, kind, delay, leader) {
    if (!el || el.classList.contains('hm-pk-rv')) return;
    el.classList.add('hm-pk-rv');
    if (kind) el.classList.add('hm-pk-rv--' + kind);
    if (delay) el.style.setProperty('--pk-d', delay + 'ms');
    if (leader && leader !== el) { (leader.__fol = leader.__fol || []).push(el); }
    all.push(el);
    enterIO.observe(el);
    exitIO.observe(el);
  }
  function stagger(list, kind, step, leader) {
    var arr = Array.prototype.slice.call(list);
    var lead = leader || arr[0];
    arr.forEach(function (el, i) { reveal(el, kind, Math.min(i, 6) * (step || 90), lead); });
  }

  // Red de seguridad: lo que ya se ve y sigue oculto aparece (scroll rápido: mientras se mueve y con entrada corta).
  function sweepRun(fast, loose) {
    var vh = window.innerHeight || 800;
    all.forEach(function (el) {
      if (el.classList.contains('pk-in')) return;
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (seen > (loose ? 0 : r.height * (fast ? 0.15 : 0.35)) && r.top < vh * 0.99) {
        if (fast) {
          el.classList.add('hm-pk-rv--fast');
          setTimeout(function () { el.classList.remove('hm-pk-rv--fast'); }, 600);
        }
        setState(el, true);
      }
    });
  }

  function init() {
    build();
    var q = function (ctx, s) { return Array.prototype.slice.call((ctx || main).querySelectorAll(s)); };

    // 1 · Todo lo que lleva tu pack
    stagger(q(pk, '.dv .center'), '', 80);
    stagger(q(pk, '.dv-card'), 's', 140);
    q(pk, '.dv-card').forEach(function (c) { stagger(q(c, '.dv-chips li'), '', 60); });
    // 2 · Hecho para las tomas fuera de casa (la foto lidera el texto y los botones)
    var teatImg = q(pk, '.teat-img')[0];
    if (teatImg) {
      reveal(teatImg, 'l');
      stagger(q(pk, '.teat .stack > *'), '', 100, teatImg);
    }
    // 3 · Mucho más que un pack
    var rot = q(pk, '.box-rot')[0];
    if (rot) {
      reveal(rot, 'l');
      stagger(q(pk, '.box .stack > *'), '', 100, rot);
    }
    // 4 · Todo lo que necesitas en un solo pack (la pista del carrusel entra entera: sus tarjetas no se animan por separado)
    stagger(q(pk, '.mo3-head > *'), '', 90);
    reveal(q(pk, '.mo3-track')[0], 's', 120);
    q(pk, '.mo3 > .wrap > .cta, .mo3 > .wrap > .mo3-dots').forEach(function (e) { reveal(e, ''); });

    // Reseñas y preguntas frecuentes de debajo (secciones de la tienda)
    q(main, '#opiniones').forEach(function (sec) {
      stagger(q(sec, '.hm-head').concat(q(sec, '.hm-revs-w'), q(sec, '.hm-revs-cta')), '', 110);
    });
    q(main, '.hm-faq').forEach(function (sec) {
      stagger(q(sec, '.hm-h2').concat(q(sec, '.hm-det'), q(sec, '.hm-note')), '', 80);
    });

    // Scroll: barrido de seguridad (rápido mientras se mueve, normal al parar)
    var lastY = window.pageYOffset, lastT = performance.now(), lastFast = 0, sweepTimer = 0;
    window.addEventListener('scroll', function () {
      var now = performance.now(), y = window.pageYOffset;
      var speed = Math.abs(y - lastY) / Math.max(1, now - lastT);
      lastY = y; lastT = now;
      if (speed > 0.9 && now - lastFast > 60) { lastFast = now; sweepRun(true); }
      clearTimeout(sweepTimer);
      sweepTimer = setTimeout(function () { sweepRun(false); }, 320);
    }, { passive: true });

    // Primero se pone el estado «oculto» y, un instante después, entra lo que ya se ve.
    document.documentElement.classList.add('hm-pk-js');
    void document.body.offsetWidth;
    requestAnimationFrame(function () { requestAnimationFrame(function () { sweepRun(false); }); });
    setTimeout(function () { sweepRun(false); }, 500);

    // Volver con atrás/adelante o a la pestaña: se repasa lo que queda a la vista varias veces
    function resweep() {
      [0, 120, 350, 800, 1600].forEach(function (t) {
        setTimeout(function () { all.forEach(function (el) { el.__pkT = 0; }); sweepRun(false, true); }, t);
      });
    }
    window.addEventListener('pageshow', resweep);
    window.addEventListener('load', resweep);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resweep(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
